import { render, staticRenderFns } from "./Capa.vue?vue&type=template&id=7705db21&scoped=true&"
import script from "./Capa.vue?vue&type=script&lang=js&"
export * from "./Capa.vue?vue&type=script&lang=js&"
import style0 from "./Capa.vue?vue&type=style&index=0&id=7705db21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7705db21",
  null
  
)

export default component.exports